import { DataValue } from 'react-apollo';
import { Money } from 'types/common';
import {
  StockPriceQuery,
  StockPriceQueryVariables,
} from 'queries/StockPrice/__generated__/StockPriceQuery';

export interface Data {
  loading: boolean;
  isPriceAvailable?: boolean;
  price?: Money;
  buyFee?: Money;
}

export const mapAskPrice = (data?: DataValue<StockPriceQuery, StockPriceQueryVariables>): Data => {
  if (!data || !data.stocksRemote || !data.stocksRemote.product) {
    return {
      loading: !data || data.loading,
    };
  }

  const { ask, close } = data.stocksRemote.product.realtimeDataPeek;

  const { buyFee } = data.stocksRemote.product.fees;

  const price = ask || close || undefined;

  return {
    loading: data.loading,
    isPriceAvailable: !!ask,
    buyFee,
    price,
  };
};
